const cards = [
  {
    title: '某顶流男星密会事件全解析：时间线、关键人物与后续影响',
    desc: '从深夜被拍到经纪人回应，再到品牌方解约，完整梳理这场娱乐圈风暴的来龙去脉。多位圈内人士匿名提供内幕信息，揭开顶流光环背后的真实面貌。',
    img: 'https://readdy.ai/api/search-image?query=Abstract%20mysterious%20night%20scene%20with%20warm%20streetlight%20glow%20and%20deep%20shadows%2C%20dark%20crimson%20and%20gold%20tones%2C%20paparazzi%20editorial%20style%2C%20cinematic%20composition%20with%20soft%20bokeh%20effect%2C%20no%20text%20no%20faces&width=800&height=500&seq=cards-01&orientation=landscape',
    tag: '深度爆料',
    time: '2小时前',
  },
  {
    title: '知名导演被举报事件持续发酵：已有五位女星发声',
    desc: '继首位女演员实名举报后，又有四位圈内女性站出来分享相似经历。行业协会已启动调查程序，多家合作品牌暂停与该导演的合作关系。',
    img: 'https://readdy.ai/api/search-image?query=Abstract%20dramatic%20composition%20with%20fragmented%20mirror%20pieces%20on%20dark%20background%2C%20deep%20burgundy%20and%20gold%20reflections%2C%20serious%20investigative%20mood%2C%20editorial%20photography%20style%2C%20no%20text%20no%20faces&width=800&height=500&seq=cards-02&orientation=landscape',
    tag: '持续追踪',
    time: '5小时前',
  },
  {
    title: '影视公司内部邮件泄露：揭秘出品方资本博弈内幕',
    desc: '一封意外泄露的内部邮件，揭开了两家头部影视公司在重点项目上的暗战。涉及金额巨大，多方利益纠缠，背后还有更多不为人知的交易细节待曝光。',
    img: 'https://readdy.ai/api/search-image?query=Abstract%20corporate%20power%20struggle%20visual%20with%20chess%20pieces%20and%20dramatic%20lighting%2C%20dark%20crimson%20and%20gold%20accents%2C%20luxurious%20boardroom%20aesthetic%2C%20cinematic%20editorial%20mood%2C%20no%20text%20no%20faces&width=800&height=500&seq=cards-03&orientation=landscape',
    tag: '独家揭秘',
    time: '8小时前',
  },
  {
    title: '吃瓜爆料每日大赛本周精选：网友投稿爆款合集',
    desc: '本周吃瓜爆料每日大赛涌现大量优质投稿，从素人爆料到圈内人实锤，我们精选了十条最受关注的爆料内容，涵盖娱乐圈、网红圈、体育圈等多个领域。',
    img: 'https://readdy.ai/api/search-image?query=Abstract%20award%20ceremony%20visual%20with%20golden%20spotlight%20and%20dark%20elegant%20background%2C%20warm%20amber%20and%20deep%20red%20tones%2C%20luxurious%20editorial%20spread%20style%2C%20cinematic%20composition%2C%20no%20text%20no%20faces&width=800&height=500&seq=cards-04&orientation=landscape',
    tag: '每日大赛',
    time: '12小时前',
  },
  {
    title: '经纪行业乱象调查：天价解约金背后的人才困局',
    desc: '深入调查国内娱乐经纪行业的霸王条款问题，多位曾遭遇不公平合约的艺人匿名分享亲身经历，揭示天价解约金与不合理分成比例背后的行业潜规则。',
    img: 'https://readdy.ai/api/search-image?query=Abstract%20chain%20and%20broken%20contract%20visual%20on%20dark%20background%2C%20warm%20crimson%20and%20gold%20accents%2C%20investigative%20journalism%20aesthetic%2C%20dramatic%20editorial%20lighting%2C%20no%20text%20no%20faces&width=800&height=500&seq=cards-05&orientation=landscape',
    tag: '行业调查',
    time: '1天前',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-2">
            深度爆料
          </h2>
          <p className="text-sm text-foreground-500">独家深度调查报道，揭开事件真相</p>
        </div>

        <div className="space-y-4 md:space-y-5">
          {cards.map((item, i) => (
            <a
              key={i}
              href="#cards"
              className="group flex flex-col sm:flex-row gap-4 md:gap-6 p-4 md:p-5 rounded-xl bg-background-50 border border-background-200 hover:border-primary-200 transition-all cursor-pointer"
            >
              <div className="flex-shrink-0 w-full sm:w-48 md:w-56 aspect-[16/10] sm:aspect-auto sm:h-36 rounded-lg overflow-hidden">
                <img
                  src={item.img}
                  alt={`吃瓜爆料深度 - ${item.title}`}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading={i >= 2 ? 'lazy' : undefined}
                />
              </div>
              <div className="flex-1 min-w-0 flex flex-col justify-center">
                <div className="flex items-center gap-2 mb-2">
                  <span className="px-2 py-0.5 rounded text-[10px] font-medium bg-primary-100 text-primary-700 whitespace-nowrap">
                    {item.tag}
                  </span>
                  <span className="text-xs text-foreground-400">{item.time}</span>
                </div>
                <h3 className="text-sm md:text-base font-heading font-bold text-foreground-800 group-hover:text-primary-600 transition-colors mb-1.5 leading-snug">
                  {item.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-500 leading-relaxed line-clamp-2">
                  {item.desc}
                </p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}